/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export enum DependencyRecordType {
    INTERFACE = 0,
    CONCRETE = 1
}
